import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';
import { motion } from 'framer-motion';

const WHATSAPP_NUMBER = "2349152474245";
const WHATSAPP_MESSAGE = "Hello OX Olorire Exchange! I'm interested in trading cryptocurrency.";

export default function FloatingWhatsApp() {
  const handleClick = () => {
    const encodedMessage = encodeURIComponent(WHATSAPP_MESSAGE);
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`, '_blank');
  };

  return (
    <motion.button
      onClick={handleClick}
      className="floating-whatsapp"
      data-testid="floating-whatsapp-btn"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      transition={{ type: 'spring', stiffness: 260, damping: 20 }}
    >
      <FaWhatsapp size={28} color="white" />
    </motion.button>
  );
}
